import { TFunction } from "i18next";
import * as Yup from "yup";

import { nullableAmount, nullableDate, nullableText } from "../../utils/validation.utils";
import { DependantMaxLength } from "./RelativesView.types";

export function createDependantSchema(t: TFunction) {
  return Yup.object().shape({
    firstName: nullableText(t, DependantMaxLength.firstName),
    birthDate: nullableDate(t).max(new Date(), t("clients.create.dateMaxToday")),
    monthlyAlimonyAmount: nullableAmount(t),
    note: nullableText(t, DependantMaxLength.note),
  });
}
